import { chakraSelectDarkMode, defaultChakraSelectStyle } from '@/constants';
import { InfoIcon } from '@chakra-ui/icons';
import {
    Badge,
    Box,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Tooltip,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { isEqual } from 'lodash';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useServices } from '../ServicesContext';
import style from './styles';
import useServicesAttributesValidation from './useServicesAttributesValidation';

export default function ListAttribute({
    attribute,
    index,
    serviceIndex,
    requiredScope,
    isBusy,
}) {
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { darkMode } = useSelector((state) => state.settings);
    const chakraSelectDark = chakraSelectDarkMode(darkMode);

    const { attributesErrors, services } = useServices();
    const error = attributesErrors.find(
        (obj) => obj.id === index && obj.serviceIndex === serviceIndex,
    );

    const [validValues] = useState(() =>
        validation.ValidValues.split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
            .map((value, index) => ({ index, value })),
    );

    const updateAttribute = services[serviceIndex].attributes[index];

    const { removeAttributeError, handleAttributeChange } =
        useServicesAttributesValidation();

    return (
        <Box sx={style.fieldContainer}>
            <FormControl isRequired={validation.Required} isInvalid={error}>
                <FormLabel sx={style.label}>
                    {attribute.name}{' '}
                    {attribute.toolTip && (
                        <Tooltip
                            label={attribute.toolTip}
                            hasArrow
                            placement="top-end">
                            <InfoIcon />
                        </Tooltip>
                    )}
                </FormLabel>
                <Box display="flex" flexDirection="row">
                    <Box w="100%" mr={1}>
                        <Select
                            value={validValues?.find(
                                (item) => item.value === updateAttribute.value,
                            )}
                            options={validValues}
                            onChange={(e) => {
                                removeAttributeError(index, serviceIndex);
                                handleAttributeChange(
                                    e.value,
                                    index,
                                    serviceIndex,
                                );
                            }}
                            placeholder="Please select an option"
                            getOptionLabel={(i) => i.value}
                            getOptionValue={(i) => i.value}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            chakraStyles={{
                                ...defaultChakraSelectStyle,
                                ...chakraSelectDark,
                            }}
                            isDisabled={
                                requiredScope < attribute.updateScope || isBusy
                            }
                        />
                    </Box>
                    {!isEqual(updateAttribute?.value, attribute.value) && (
                        <Box alignContent="center" ml={1}>
                            <Badge colorScheme="orange">Unsaved</Badge>
                        </Box>
                    )}
                </Box>

                {error ? (
                    <FormErrorMessage>{error.message}</FormErrorMessage>
                ) : attribute?.description ? (
                    <FormHelperText>{attribute?.description}</FormHelperText>
                ) : null}
            </FormControl>
        </Box>
    );
}
